import React from 'react';

const TileContentContext = React.createContext({
  orientation: 'horizontal'
});

export default TileContentContext;
